import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { HeaderService } from './Services/header.service';
import { AuthService } from './Services/auth-service.service';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'at Harris County Universal Services';

  authSub: Subscription;
  authenticated: boolean;
  inAdmin: boolean;

  constructor(private headerService: HeaderService, private authService: AuthService, private router: Router) {
    this.authenticated = false;
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (val.urlAfterRedirects.indexOf('applications') >= 0) {
          this.inAdmin = false;
        } else {
          this.inAdmin = true;
        }
      }
    });
  }

  ngOnInit(): void {
    this.authSub = this.headerService.authorized$.subscribe(
      auth => {
        this.authenticated = auth;
      });
  }


}
